import React from 'react';

import styles from './LoggedOut.scss';

import { showLoginModal, showRegisterModal } from '../authInterface';
import LoggedOutMessages from './LoggedOutMessages';

export const LoggedOut = () => (
    <div className={styles.wrapper}>
        {LoggedOutMessages.map((msg, index) => (
            <div key={`body-${index}`} className={styles.messageText}>
                {msg}
            </div>
        ))}
        <div className={styles.linkText}>
            Please{' '}
            <a className={styles.link} data-tn="log-in-link" onClick={showLoginModal}>
                Log In
            </a>{' '}
            or{' '}
            <a className={styles.link} data-tn="sign-up-link" onClick={showRegisterModal}>
                Sign Up
            </a>
            .
        </div>
    </div>
);

LoggedOut.displayName = 'LoggedOut';

export default LoggedOut;
